// extracted by mini-css-extract-plugin
export var parcelRow = "_vo-0";